import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
	const { pathname } = useLocation();
	const navigationType = useNavigationType();

	useEffect(() => {
		if (navigationType === "PUSH") {
			const scroll = setTimeout(() => {
				window.scrollTo({ top: 0, left: 0 });
			}, 50); // ۵۰ میلی‌ثانیه تأخیر

			return () => clearTimeout(scroll);
		}
	}, [pathname, navigationType]);

	return null;
};

export default ScrollToTop;
